import React from 'react';
import { connect } from 'react-redux';
import { AjaxSpinner, Button, MessagePopupCore, MessagePopupPositions, MessagePopupTypes } from 'dts-react-common';
import { Redirect, withRouter } from "react-router-dom";
import SideBar from "../sidebar/SideBar";
import { isAuthenticated, MENU_PATHS } from '../misc/Shared';
import Webservice from '../App/Webservice';
import Icon from "../misc/Icon";
import jwt from 'jsonwebtoken';

const propTypes = {};

const defaultProps = {};

const mapStateToProps = state => ({});

class PageLogin extends React.Component {
    constructor(props) {
        super(props);
        sessionStorage.removeItem('userToken');
    }

    state = {
        isAjaxing: false,
        redirect: null,
        emailAddress: '',
        password: ''
    }

    cancel() {
        this.setState({ isAjaxing: false });
        document.getElementById("loginForm").reset();
    }

    submit() {
        this.setState({ isAjaxing: true });
        //this.props.history.push(MENU_PATHS.VETERANCONFIRMATIONPAGE);
        let authRequest = {
            emailAddress: this.state.emailAddress,
            password: this.state.password
        }
        Webservice.authentication.authenticationRequest(authRequest)
            .then(response => {
                sessionStorage.setItem('userToken', response.data);
                const userToken = jwt.decode(response.data, { complete: true });
                sessionStorage.setItem('name', userToken.payload.name);
                isAuthenticated() && this.setState({ redirect: MENU_PATHS.VETERANCONFIRMATIONPAGE, isAjaxing: false });
             
             })
            .catch(error => {
                
                console.error('error', error);
                this.setState({ isAjaxing: false });
                MessagePopupCore.addMessage({
                    message: `Unable to login. Invalid email address or password, please try again.`,
                    type: MessagePopupTypes.SNACKBAR,
                    position: MessagePopupPositions.TOP_CENTER,
                    icon: Icon.iconAlert,
                    className: 'warning',
                });
            })

    }

    render() {
        if (this.state.redirect) {
            return <Redirect to={this.state.redirect} />
        }
        return (
            <div>
                <h1 className="title-page">WELCOME TO VETERAN VERIFICATION SYSTEM </h1>
                <div className="loginPage-container">
                    <h2 className="text-left">Sign In </h2>
                    <form className="loginForm-container" id="loginForm">
                        <div className="custom-field">
                            <span className="custom-label">Email Address</span>
                            <input className="custom-input" type="text" onChange={e => this.setState({ emailAddress: e.target.value })} />
                        </div>
                        <div className="custom-field">
                            <span className="custom-label">Password</span>
                            <input className="custom-input" type="password" onChange={e => this.setState({ password: e.target.value })} />
                        </div>
                    </form>
                </div>
                <div className="page-actions">
                    
                    <Button label="Login" onClick={() => { this.submit(); }} />
                    <Button label="Cancel" onClick={() => { this.cancel(); }} />
                </div>
                <React.Fragment>
                    {this.state.isAjaxing && <div className='message-display'> <AjaxSpinner size={40} /> </div>}
                </React.Fragment>
            </div>



        );
    }
}

PageLogin.propTypes = propTypes;
PageLogin.defaultProps = defaultProps;


export default withRouter(connect(mapStateToProps)(PageLogin));